export const projects = [
  {
    title: "Notifications scraper",
    subtitle: "Python, Task Scheduling",
    description:
      "Developed this application as a freelancer. It is a bot to automatically scrape newly added data to get the latest comments/ notifications on govt. job",
  },
  {
    title: "Telugu Panchangam Calculator ",
    subtitle: "Java, Springboot, Microservices, React.js",
    description:
      "Developed this application as a freelancer. This application is used to calculate the Thithi, Nakshatra and other timeseeking details based on the coordinates of Sun and Moon from Vedas. In General, those coordinates were given based on time as metric",
  },
    {
      title: "Public Police Interface Application with criminal face recognition",
      subtitle: "Android, Java, Firebase, Django, Bootstrap, face-recognition library",
      description:
        "Developed an Android Application for public to lodge a complaint, apply NOC, and perform criminal face recognition and a Web Application for police to verify complaints,NOC applications and manage criminal database",
    },
    
    {
      title: "Anti-Theft Bike Parking Application",
      subtitle: "Android, Java, Firebase, RaspberryPI",
      description:
        "Developed this project using Raspberry PI3 with GPS Module to track a bike when the bike is parked. An Android Application is used to track the GPS only when parking mode is enabled",
    },
    {
        title: "Student Scholarship portal",
        subtitle: "Bootstrap4, PHP, MySQL ",
        description:
          "Developed this application in a Hackathon. In this project, the Web Application is used by students to apply, renew or verify the status of scholarships and by officers to manage the applications respectively",
      },
    {
      title: "Cricket Score Calculator",
      subtitle: "C",
      description:
        " A simple Cricket score calculator developed using C and Data structures which involves marking and storing scores of a cricket match",
    }, 
  ];
  
  export const workExperience = [
    {
      title:
        "Software Engineer",
      skill: "Java, RPC, Python, Bazel, Kotlin, Junit, SQL, NoSQL, Android",
      company: "Google",
      description:"Currently working on developing new features and improve development infrastructure of G1 and Photos product in Android, Web and iOS platforms",
    },
    {
      title:
        "Software Engineer",
      skill: "Java, Angular 15, Springboot, Spring JPA, REST-API, PostgreSQL, MsSql, Oracle SQL, Docker, Kubernetes, Solr",
      company: "OpenText",
      description:"currently working on feature development in Exstream (CCM tool) as a full stack developer (Backend heavy)",
    },
    {
      title:
        "Teaching Assistant Volunteer",
      skill: "Beginner to Advanced Data Structures and Algorithms",
      company: "Smart Interviews",
      description:"Mentored around 300 students and professionals in teaching DSA. Helped in resolving bugs of their code and teach concepts",
    },
    {
      title:
        "Associate Member Technical Staff",
      skill: "Java, React.js, REST-API, SQL, Persistant Objects (Springboot-JPA) ",
      company: "Model N",
      description:"Worked on resolving and triaging critical bugs and building enhancements of Revenue Management Application suite of Life Sciences industries using Java, Oracle SQL, React.Js, REST-API, Mockito and JPA by following Agile Principles. Used SQL tuning operations and techniques in improving performances of SQL queries. Contributed to optimizing product suite setup using java and Shell. Used Java8 DateTime API to add TimeZone properties to the application using Java8 to add application support to users from different Timezone or countries. Worked on designing and developing a parser to import and export .edi files to the system by following serialization techniques. Worked on adding validations and data migrations from version to version. I have taken on the responsibility of providing guidance and support to several New College Grads and Joiners during their training and initial phase of work. Delivered Knowledge Transfer sessions on Model N product suite frameworks and architecture to co-peers",
    },
    {
      title:
        "Android Application Developer Intern",
      skill: "Java, Andriod, Multithreading, MySQL, AWS",
      company: "Caravel.ai",
      description:"Worked on developing an Android Application for students to manage student activities at various clubs of college using Android, Java, MySQL",
    },
  ];
  
  export const education = [
    {
        college:"Chaitanya Bharathi Institute of technology",
        study:"Bachelor of Engineering (CSE)",
        location:"Gandipet, Hyderabad",
        year:"2017-2021",
        cgpa:"8.37",
    },
    {
        college:"Sri Chaitanya Junior College",
        study:"Intermediate M.P.C. (TSBIE)",
        location:"Gandipet, Hyderabad",
        year:"2015-2017",
        cgpa:"98%",
    },
    {
        college:"Chinna Munshi Public School",
        study:"SSC (TBSC)",
        location:"Chennur, Mancherial",
        year:"2015",
        cgpa:"9.2",
    },
  ]
  
  export const skills = [
    "Java",
    "Python",
    "C",
    "PHP",
    "SQL",
    "NoSQL",
    "CI/CD basics",
    "Docker basics",
    "Kubernetes basics",
    "Springboot",
    "PostgreSQL",
    "JavaScript",
    "React Intermediate",
    "Angular Intermediate",
    "LLD basics",
    "HLD",
    "Node.js",
    "AWS Basics",
    "System Design",
    "AI/ML concepts",
    "RPCs"
  ];
  